export default __webpack_public_path__ + "static/media/background-05@2x.5ebc1dfc.webp";